import LegalDocumentPage from "./LegalDocumentPage";

function TermsAndConditionsPage() {
  return (
    <LegalDocumentPage
      documentType="terms"
      title="Términos y condiciones"
      description="Consulta las condiciones aplicables al uso de Wiblo y sus servicios."
    />
  );
}

export default TermsAndConditionsPage;